export function replaceQueryParam(
  oldURL: string,
  key: string,
  value: any
): string {
  const path = oldURL.split("?")[0];
  const queryStr = oldURL.split("?")[1] || "";
  if (queryStr.length > 0) {
    const params = queryStr.split("&").reduce((res, qStr) => {
      const parts = qStr.split("=");
      if (parts.length === 2) {
        res[parts[0]] = parts[1];
      }
      return res;
    }, {});
    params[key] = value;
    return `${path}?${Object.keys(params)
      .map((key) => {
        return `${key}=${params[key]}`;
      })
      .join("&")}`;
  } else {
    return `${oldURL}?${key}=${value}`;
  }
}
